<template>
  <v-form lazy-validation>
    <v-btn
      dark
      v-show="!$storeCommun.ReadOnly"
      color="secondary"
      @click="addAutreBourse"
    >
      {{ $storeUm6p.Label.Ajouter }}
    </v-btn>
    <!-- Début Liste langues -->
    <v-data-table
      :headers="$storeUm6p.Label.Bourse.HeadersTab"
      :items="$storeCommun.ListeAutresBourses"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item="{ item, index }">
        <tr v-if="!item.Supprimer">
          <td class="text-xs-left">
            <v-text-field
            v-model="item.Organisme"
            :rules="$storeReglesBourse.obligatoire"
            class="asterisk"
            dense
            >
            </v-text-field>
          </td>
          <td class="text-xs-left">
            <v-menu
              v-model="menu.dateDebut"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  clearable
                  :v-model="formatDate(item.Debut)"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="item.Debut = null"
                  :value="formatDate(item.Debut)" 
                  @input="updateValueDebut($event, item)"
                />
              </template>
              <v-date-picker
                v-model="item.Debut"
                @input="menu.dateDebut = false"
              />
            </v-menu>
          </td>
          <td class="text-xs-left">
            <v-menu
              v-model="menu.dateFin"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  clearable
                  :v-model="formatDate(item.Fin)"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="item.Fin = null"
                  :value="formatDate(item.Fin)" 
                  @input="updateValueFin($event, item)"
                />
              </template>
              <v-date-picker
                v-model="item.Fin"
                @input="menu.dateFin = false"
              />
            </v-menu>
          </td>
          <td class="text-xs-left">
            <VuetifyMoney
              v-model="item.MontantDirham"
              v-bind:readonly="readonly"
              v-bind:disabled="disabled"
              v-bind:outlined="outlined"
              v-bind:clearable="clearable"
              v-bind:options="optionsDH"
              dense
            />
          </td>
          <td>
            <v-icon
             v-if="!$storeCommun.ReadOnly && index > 0"
              small
              @click="deleteItem(item)"
              v-show="!$storeCommun.ReadOnly"
              >{{ icons.mdiDelete }}</v-icon
            >
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-form>
</template>
<script>
import VuetifyMoney from "../VuetifyMoney";
import { mdiDelete } from "@mdi/js";

export default {
  components: {
    VuetifyMoney,
  },
  data() {
    return {
      // Param des rubriques revenus
      label: "",
      readonly: false,
      disabled: false,
      outlined: false,
      clearable: false,
      optionsDH: {
        locale: "fr-FR",
        prefix: "DH",
        suffix: "",
        length: 9,
        precision: 2,
      },
      menu: {
        dateDebut: false,
        dateFin: false,
      },
      // Icon importés depuis mdi/js pour les icones d'édition/suppression
      icons: {
        mdiDelete,
      },
      // Réaffecter l'objet global pour forcer la maj en temps réel
      $storeCatalogue: this.$storeCatalogue,
      $storeDemandeBourse: this.$storeDemandeBourse,
      $storeCommun: this.$storeCommun,

      // Validation du formulaire
      valid: false,
    };
  },
  mounted() {},
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    updateValueDebut(event, item) {
      item.Debut = event.target.value;
    },
    updateValueFin(event, item) {
      item.Fin = event.target.value;
    },
    addAutreBourse(){
      let bourse = {
        IdCrypte: null,
        Supprimer: false,
        Organisme: null,
        Debut: null,
        Fin: null,
        MontantDirham: null,
      };

      this.$storeCommun.ListeAutresBourses.push(bourse);
    },
    deleteItem(item) {
      if (confirm("Etes-vous sûr de vouloir supprimer cette ligne?")) {
        // on récupère l'item depuis le store
        this.editedIndex = this.$storeCommun.ListeAutresBourses.indexOf(item);
        // on affecte l'item local pour récupèrer les valeurs
        let autrebourse = Object.assign({}, item);

        // on affecte la valeur supprimer à true
        autrebourse.Supprimer = true;

        // on modifie l'item dans le store
        Object.assign(
          this.$storeCommun.ListeAutresBourses[this.editedIndex],
          autrebourse
        );

        this.editedIndex = -1;
      }
    },
  },
};
</script>
<style scoped src="@/assets/css/DemandeBourse.css"></style>
